import { gateway } from "../../../gateway";
import { ISecretDTO } from "../interfaces/ISecretDTO";

export const createPasswordVaultAction = async (dto: ISecretDTO, imageFile: File | null) => {
  const token = sessionStorage.getItem("token");

  const url = "/passwords";

  if (!imageFile) {
    const res = await gateway.post(url, dto, {
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    });
    return res.data;
  }

  const form = new FormData();
  form.append("title", dto.title?.trim() ?? "");
  form.append("usernameEmail", dto.usernameEmail ?? "");
  form.append("password", dto.password ?? "");
  form.append("websiteUrl", dto.websiteUrl ?? "");
  form.append("notes", dto.notes ?? "");
  form.append("highSecurity", String(Boolean(dto.highSecurity)));
  form.append("imageFile", imageFile);

  const res = await gateway.post(url, form, {
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });

  return res.data;
};
